<template>
  <div>
    <div :id="playerId"></div>
  </div>
</template>

<script>
import { eventBus } from "../../main"; // Asegúrate de que el path es correcto

export default {
  props: {
    videoId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      player: null,
      minutes: null,
    };
  },
  watch: {
    videoId(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        const videoId = this.extractVideoId(newVal);
        if (videoId) {
          console.log('Cambiando videoId:', videoId);
          this.createPlayer(videoId);
        }
      }
    }
  },
  mounted() {
    console.log('mounted');
    this.loadYouTubeAPI();
  },
  methods: {
    extractVideoId(url) {
      const match = url.match(/[?&]v=([^&#]+)/) || url.match(/youtu\.be\/([^?]+)/);
      return match ? match[1] : url;
    },
    loadYouTubeAPI() {
      try {
        if (window.YT && window.YT.Player) {
          console.log('Entró a loadYouTubeAPI');
          this.createPlayer(this.extractVideoId(this.videoId));
        } else {
          console.log('No entró a loadYouTubeAPI');
          const script = document.createElement("script");
          script.src = "https://www.youtube.com/iframe_api";
          script.async = true;
          script.defer = true;
          script.onload = () => {
            window.onYouTubeIframeAPIReady = () => this.createPlayer(this.extractVideoId(this.videoId));
          };
          document.head.appendChild(script);
        }
      } catch (error) {
        console.log('Error en loadYouTubeAPI:', error);
      }
    },
    createPlayer(videoId) {
      try {
        console.log('----CreatePlayer');
        
        if (this.player) {
          console.log('Destruyendo reproductor anterior');
          this.player.destroy();
        }
        
        this.player = new window.YT.Player(this.playerId, {
          height: "100%", // Cambia el alto a un porcentaje
          width: "100%",  // Mantiene el ancho al 100%
          videoId: videoId,
          playerVars: {
            rel: 0,
            modestbranding: 1
          },
          events: {
            onReady: this.onPlayerReady
          }
        });
      } catch (error) {
        console.log('Error en createPlayer:', error);
      }
    },
    onPlayerReady(event) {
      try {
        console.log('Reproductor listo');
        
        let duration = event.target.getDuration();
        let minutes = (duration / 60) + 0.5; // Sumar 0.5 para redondear manualmente
        let roundedMinutes = (minutes | 0) || 1; // Truncar y asegurar mínimo 1

        console.log('Duración del video:', roundedMinutes, 'minutos');
        
        this.minutes = roundedMinutes;
        eventBus.$emit("videoDurationYT", this.minutes);
      } catch (error) {
        console.log('Error en onPlayerReady:', error);
      }
    }
  },
  computed: {
    playerId() {
      return `player-${this._uid}`; // asegura id único
    }
  },
};
</script>

<style scoped>
#player {
  width: 100% !important;
  height: auto !important;
  aspect-ratio: 16 / 9; /* Mantiene la proporción 16:9 */
}
</style>
